import React from 'react';

// Deterministic pink/lilac palette; hash the name to pick a hue.
const PALETTE = [
  { bg: '#fbe8ef', fg: '#8f4a63' },  // pink
  { bg: '#e6dbf1', fg: '#6b4e8a' },  // lilac
  { bg: '#f5e3d5', fg: '#8b5a2c' },  // peach
  { bg: '#dceff0', fg: '#3a7075' },  // teal
  { bg: '#e8ecc7', fg: '#6b7530' },  // olive
  { bg: '#f3dede', fg: '#8a3a3a' },  // rose
  { bg: '#dce3f0', fg: '#3d5891' },  // slate blue
  { bg: '#efe1e9', fg: '#7a4a5f' },  // dusty pink
];

const hashCode = (s) => {
  const str = String(s || '');
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
};

const getInitials = (name) => {
  const s = String(name || '').trim();
  if (!s) return '?';
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/**
 * <InitialsAvatar name="Bec Harmer" size={40} />
 * Renders a colored circle with the user's initials.
 * size is in pixels; className passes-through for custom overrides.
 */
const InitialsAvatar = ({ name, size = 32, className = '', title }) => {
  const initials = getInitials(name);
  const palette = PALETTE[hashCode(name || 'x') % PALETTE.length];
  const style = {
    width: size,
    height: size,
    background: palette.bg,
    color: palette.fg,
    fontSize: Math.max(10, Math.round(size * 0.4)),
    lineHeight: 1,
  };
  return (
    <div
      style={style}
      title={title || name}
      className={`inline-flex items-center justify-center rounded-full font-semibold select-none shrink-0 ${className}`}
      data-testid="initials-avatar"
    >
      {initials}
    </div>
  );
};

export default InitialsAvatar;
